import { STATION_CHARGING_SUMMARY } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  stationChargingSummaries: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const stationChargingSummaryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case STATION_CHARGING_SUMMARY.REQUEST: {
      return { ...state, isLoading: true };
    }
    case STATION_CHARGING_SUMMARY.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        stationChargingSummaries: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case STATION_CHARGING_SUMMARY.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default stationChargingSummaryReducer;
